import * as React from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';
import { CircleBone, TextBone } from '../../atoms';
import { CardItemBone } from '../CardItemBone';

interface ActivityBoneProps {
    /** Masquer l'avatar/icône de profil */
    hideProfilPicture?: boolean;
    /** Indique si c'est le dernier élément de la liste */
    isLast?: boolean;
    /** Styles personnalisés pour le titre */
    titleSxProps?: SxProps<Theme>;
    /** Styles personnalisés pour le contenu */
    contentSxProps?: SxProps<Theme>;
}

export const ActivityBone: React.FunctionComponent<ActivityBoneProps> = function ({
    hideProfilPicture = false,
    isLast = false,
    titleSxProps = {},
    contentSxProps = {},
}: ActivityBoneProps) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                position: 'relative',
                minHeight: '60px',
            }}
        >
            {!isLast && (
                <Box
                    sx={{
                        position: 'absolute',
                        left: '20px',
                        top: '50px',
                        bottom: '10px',
                        width: '2px',
                        backgroundColor: theme.palette.grey[300],
                        zIndex: 0,
                    }}
                />
            )}

            <Box sx={{ marginRight: '16px', zIndex: 1 }}>
                {!hideProfilPicture && <CircleBone sx={{ width: '40px', height: '40px' }} />}
            </Box>

            <Box sx={{ flex: 1, paddingBottom: '20px' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 0.5,
                        marginBottom: '8px',
                    }}
                >
                    <TextBone
                        textVariant="body2"
                        sx={{ width: '120px', ...titleSxProps }}
                    />
                    <TextBone
                        textVariant="caption"
                        sx={{ width: '80px', ...titleSxProps }}
                    />
                </Box>

                <CardItemBone
                    contentWidth="500px"
                    contentHeight="60px"
                    sx={{
                        borderRadius: '8px',
                        marginBottom: '12px',
                        ...contentSxProps,
                    }}
                />
            </Box>
        </Box>
    );
};
